import React from 'react';

import { useDispatch } from 'react-redux';

import { addNotificationAction } from '../action/notifications/notifications';

import { LegacyAnnouncementComposer } from '../employee-messages/legacy/legacy-announcement-composer';
import { NewMessageComposer } from '../employee-messages/new-message-composer/new-message-composer';
import { FeatureFlagged, FeatureGatedVariant } from '../feature-gates/feature-flagged';
import { FeatureGates } from '../feature-gates/feature-gates';
import { UiDialog } from '../ui/ui-dialog';

type InputProps = {
  orgId: number;
  onClose: () => void;
  notification: string;
  initialMessage: string;
};

export const ReferralRequestDialog = ({
  notification,
  onClose,
  initialMessage,
  orgId,
}: InputProps) => {
  const dispatch = useDispatch();
  const handleAnnouncementSent = () => {
    onClose();
    dispatch(
      addNotificationAction({
        key: notification,
        message: notification,
      }),
    );
  };

  return (
    <UiDialog onClose={onClose} title="Ask For Referrals" size="sm">
      <FeatureFlagged
        flagName={FeatureGates.INTEGRATED_MESSAGING}
        variant={FeatureGatedVariant.HIDE_ON_FLAG}
      >
        <LegacyAnnouncementComposer
          defaultToAllEmployees
          hideThread
          initialMessage={initialMessage}
          onMessageSent={handleAnnouncementSent}
          orgId={orgId}
          onClose={onClose}
        />
      </FeatureFlagged>
      <FeatureFlagged
        flagName={FeatureGates.INTEGRATED_MESSAGING}
        variant={FeatureGatedVariant.SHOW_ON_FLAG}
      >
        <NewMessageComposer
          orgId={orgId}
          onMessageSent={handleAnnouncementSent}
          onClose={onClose}
          initialMessage={initialMessage}
          hideThread
          hideEmployeeOptions
          defaultToAllEmployees
        />
      </FeatureFlagged>
    </UiDialog>
  );
};
